import { render, staticRenderFns } from "./AdminSuperMemberBadges.vue?vue&type=template&id=4447b041&scoped=true&lang=pug&"
import script from "./AdminSuperMemberBadges.vue?vue&type=script&lang=js&"
export * from "./AdminSuperMemberBadges.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuperMemberBadges.vue?vue&type=style&index=0&id=4447b041&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4447b041",
  null
  
)

export default component.exports